/**
 * Swiper dependencies
 *
 * @see https://swiperjs.com/get-started
 */
import { Swiper } from 'swiper';
import { Autoplay, Keyboard, Navigation, Pagination } from 'swiper/modules';

/**
 * Initialize the slider.
 *
 * @param {Element} container HTMLElement.
 * @param {Object}  options   Slider parameters.
 *
 * @return {Object} Returns initialized slider instance.
 *
 * @see https://swiperjs.com/swiper-api#parameters
 */
export function SwiperInit(container, options = {}) {
  const parameters = {
    slidesPerView: 'auto',
    spaceBetween: 25,
    centeredSlides: options?.centerSlides ?? false,
    autoplay: options?.autoplay ?? false,
    freeMode: true,
    createElements: false,
    grabCursor: options?.grabCursor ?? true,
    initialSlide: 0,
    keyboard: true,
    modules: [Autoplay, Keyboard, Navigation, Pagination],
    navigation: {
      nextEl: '.swiper-button-next3',
      prevEl: '.swiper-button-prev3',
    },
    pagination: { enabled: options?.pagination ?? false, clickable: true },
    simulateTouch: options?.simulateTouch ?? true,
  };

  return new Swiper(container, parameters);
}
